<template>
    <div v-if="!this.isEmpty(this.getSelectedDay)" class="dgth-display-events">
        <div class="title">
            <div class="day">
                <span>{{ this.getSelectedDay.title }}</span>
            </div>
        </div>
        <div class="events-list">
            <div v-for="(value, name) in this.getSelectedDay.data" v-bind:key="index" class="event">
                <div class="inner">
                    <div class="time">
                        <span>{{ name }}</span>
                    </div>
                    <div class="classes">
                        <div v-for="(item, index) in value" class="class-item">
                            <div class="name">
                                {{ item.course }}
                            </div>
                            <span class="sep">/</span>
                            <div class="professors">
                                <div v-for="prof in item.professors" class="prof">
                                    {{ prof }}
                                </div>
                            </div>
                            <div class="location">
                                {{ item.location }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    export default {

        created() {

        },
        data () {
            return {
                // selectedDay: {}
            }
        },
        methods: {
            isEmpty(obj) {
                return Object.keys(obj).length === 0;
            }
        },
        computed: {
            ...mapGetters([
                'getSelectedDay'
            ])
        }
    }
</script>

<style lang="scss">
    .dgth-display-events {
        margin-top: 50px;

        .day {

            span {
                text-transform: capitalize;
                font-weight: 700;
            }
        }

        .events-list {
            margin-top: 30px;

            .inner {
                display: flex;
                flex-direction: column;
                align-items: flex-start;

                @media (min-width: 768px) {
                    flex-direction: row;
                    align-items: initial;
                }
            }

            .time {
                display: flex;
                align-items: center;
                padding: 8px 20px;
                flex-shrink: 0;
                background: #e5ecfc;
                font-weight: 700;
                border-radius: 5px;
                color: #243e63;
            }

            .classes {
                margin-top: 20px;
                width: 100%;

                @media (min-width: 768px) {
                    margin: 0 0 0 20px;
                    padding: 10px 0;
                }
            }

            .class-item {
                display: flex;
                flex-direction: column;
                width: 100%;
                padding-right: 100px;

                @media (min-width: 768px) {
                    align-items: center;
                    flex-direction: row;
                    padding: 0;
                }
            }

            .location {
                display: flex;
                align-items: center;
                justify-content: center;
                border: 1px solid #f5f5f5;
                padding: 8px 15px;
                font-weight: 700;
                margin-left: auto;
                min-width: 68px;
                text-align: center;
                transform: translate(100px, -100%);

                @media (min-width: 768px) {
                    transform: none;
                }
            }

            .name {
                font-weight: 700;

                @media (min-width: 768px) and (max-width: 992px) {
                    flex: 1;
                }
            }

            .sep {
                display: none;
                margin: 0 15px;

                @media (min-width: 768px) {
                    display: inline-block;
                }
            }

            .professors {
                display: flex;
                flex-wrap: wrap;
                flex: 1;
            }

            .prof {
                font-weight: 700;
                color: #989898;

                &:not(:last-child) {

                    &::after {
                        content: ', ';
                    }
                }
            }

            .event {
                margin-top: 30px;

                @media (min-width: 768px) {
                    margin-top: 15px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/DisplayEvents.vue